import { Spinner } from "@components/misc"
import { HARISENIN_PUBLIC_LOGO } from "@constants/const/pictures"
import { flex_center } from "@constants/styles"
import { GoogleLoginData } from "@interfaces/auth"
import GoogleLogin from "@leecheuk/react-google-login"
import AuthServices from "@lib/api/services/auth.services"
// import { useAnalytics } from "@lib/context/AnalyticsContext"
import { calculateAge } from "@lib/functions"
import clsx from "clsx"
import Image from "next/image"
import { FC, useState } from "react"

export interface GoogleLoginProps {
  redirect?: string
  handleError: (a: string) => void
}

export const GoogleLoginButton: FC<GoogleLoginProps> = ({ redirect, handleError }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const auth = new AuthServices()
  // const { analytics } = useAnalytics()

  async function handleGoogleLogin(response: any) {
    const userProfile = response.profileObj
    const userFullname = userProfile.name
    const userEmail = userProfile.email
    const googleId = userProfile.googleId

    setIsSubmitting(true)

    try {
      handleError("")

      const res = await auth.googleLogin({
        email: userEmail,
        fullName: userFullname,
        googleId,
      })

      if (res.isFailure) {
        setIsSubmitting(false)
        const errorMessage = res.error.message
        return handleError(errorMessage)
      }
      const result = res.getValue()

      if (result.new_user === 1) {
        return window.location.assign("/biodata")
      }

      const tokenData = result as GoogleLoginData

      // analytics.identify(tokenData.id, {
      //   address: {
      //     city: "",
      //     country: "Indonesia",
      //     postalCode: "",
      //     state: "",
      //   },
      //   age: calculateAge(tokenData.user_birthday as Date),
      //   avatar: tokenData.user_picture,
      //   birthday: new Date(tokenData.user_birthday as Date),
      //   email: tokenData.user_email,
      //   firstName: tokenData.user_firstname,
      //   gender: result.user_gender == 1 ? "Male" : "Female",
      //   lastName: tokenData.user_lastname,
      //   name: tokenData.fullname,
      //   phone: result.user_phone_number,
      // })

      // analytics.track("Signed In", {
      //   method: "email",
      // })

      if (!redirect) {
        window.location.reload()
      } else {
        window.location.assign(redirect)
      }
    } catch (error: any) {
      setIsSubmitting(false)
      handleError("Terjadi kesalahan. Silahkan coba lagi")
    }
  }

  function handleGoogleError(res: any): void {
    console.log(res)
    // console.log(res)
  }

  return (
    <GoogleLogin
      clientId={process.env.GOOGLE_CLIENT_ID || process.env.HARISENIN_GOOGLE_CLIENT_ID || ""}
      render={(renderProps) => (
        <button
          disabled={isSubmitting}
          onClick={renderProps.onClick}
          className={clsx(
            flex_center,
            "relative px-4 py-[22px] h-[50px] text-grey-69 w-full border border-grey-69 rounded"
          )}
        >
          <>
            {isSubmitting ? (
              <Spinner />
            ) : (
              <>
                <Image
                  src={`${HARISENIN_PUBLIC_LOGO}/logo_google.png`}
                  alt="google"
                  className="h-7 absolute left-[10%]"
                  width={28}
                  height={28}
                />
                <span>Lanjutkan dengan Google</span>
              </>
            )}
          </>
        </button>
      )}
      buttonText="Login"
      onSuccess={handleGoogleLogin}
      onFailure={handleGoogleError}
      cookiePolicy={"single_host_origin"}
    />
  )
}
